<template>
  <div :class="['layer-popup-wrap', isOpen ? 'open' : '']">
    <div class="layer-popup" tabindex="0">
      <h4 class="pop-tit">다운로드</h4>
      <div class="pop-cont">
        <table class="pop-table">
          <caption>다운로드</caption>
          <colgroup>
            <col class="res-col">
            <col>
          </colgroup>
          <tbody>
          <tr>
            <th>파일형태</th>
            <td>
              <div class="inp-wrap">
                  <span class="inp-pop">
                    <label><input v-model="downType" value=".xlsx" type="radio" name="download" checked> 엑셀(xlsx)</label>
                  </span>
                <span class="inp-pop">
                    <label><input v-model="downType" value=".csv" type="radio" name="download" > CSV</label>
                  </span>
                <span class="inp-pop">
                    <label><input v-model="downType" value=".txt" type="radio" name="download"> TXT</label>
                  </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="pop-btn-box align-r">
          <button type="button" class="pop-btn bg-blue" @click="exportData">다운로드</button>
        </div>
      </div>
        <button type="button" class="btn-pop-close" @click="close"><span class="hidden">닫기</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownLoadPopup",
  props: {
    statId: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false,
      downType: ".xlsx",
      popBtn: ''
    }
  },

  methods: {
    reset() {
    },

    open(evt) {
      this.reset();
      this.isOpen = true;

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn = evt.target
      setTimeout(() => {
        const popup = this.$parent.$refs.downLoadPopup.$el
        popup.firstChild.focus()
      }, 300);
    },

    close() {
      this.isOpen = false;

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn.focus()
    },

    exportData () {
      this.$emit('exportSheetData', this.downType);
      this.close()
    },


  },

}
</script>
